import { components } from 'react-select';
import ColorConstants from '../../../shared/constants/ColorConstants';

export const SelectDropdownIndicator = components.DropdownIndicator;

export const SelectDropdownIndicatorStyles = styles => ({
    ...styles,
    color: ColorConstants.matterhorn,
    '&:hover': {
        color: ColorConstants.charcoal,
    },
});
